import angular from 'angular';
angular.module('commonServices').filter('parseJson', [
  function() {
    return function(text, property) {
      return JSON.parse(text)[property];
    };
  },
]);
